import * as React from 'react';
import { ITranslationSchema } from '../../interfaces/ITranslationFields';
import Payment, { PaymentProvider } from '../../domain/entities/Payment/Payment';

export interface IPaymentMethodViewProps {
  payment?: Payment;
  paymentProvider?: PaymentProvider;
  translations?: ITranslationSchema;
}

type componentType = React.ComponentType<IPaymentMethodViewProps>;

export interface IPaymentMethodViewRegistry {
  register(id: string, componentClass: componentType): void;

  getComponentClass(id: string): componentType | undefined;
}

export class PaymentMethodViewRegistry implements IPaymentMethodViewRegistry {
  private registry: Map<string, React.ComponentType>;

  constructor() {
    this.registry = new Map();
  }

  public getComponentClass(id: string): React.ComponentType | undefined {
    return this.registry.get(id);
  }

  public register(id: string, componentClass: React.ComponentType): void {
    this.registry.set(id, componentClass);
  }
}
